import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { buildQueryParams } from "@/shared/utils/utils";
interface TagMarketing {
  id: number;
  label: string;
  branch_id?: number | null;
}

type NewTagMarketing = Omit<
  TagMarketing,
  "id" | "created_at" | "updated_at"
> & { id?: number };

export const taskApi = api
  .enhanceEndpoints({
    addTagTypes: ["taskAppi"],
  })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      getAllTasks: builder.query({
        query: (params) => ({
          url: "tasks",
          method: RequestMethod.GET,
          params: buildQueryParams(params),
        }),
      }),

      tasks: builder.query<any, void>({
        query: () => ({
          url: `admin/tasks`,
          method: RequestMethod.GET,
        }),
        providesTags: (result) => result,
      }),

      //tag
      tags: builder.query<any, { branch_id: string | number }>({
        query: ({ branch_id }: { branch_id: string | number }) => ({
          url: `admin/tags/all?branch_id=${branch_id}`,
          method: RequestMethod.GET,
        }),
        providesTags: (result) =>
          result
            ? result.map((tag: TagMarketing) => ({ type: "Tags", id: tag.id }))
            : [{ type: "Tags", id: "LIST" }],
      }),

      taskLabels: builder.query<any, { branch_id: string }>({
        query: ({ branch_id }: { branch_id: string }) => ({
          url: `tasks/labels?branch_id=${branch_id}`,
          method: RequestMethod.GET,
        }),
        providesTags: (result) => result,
      }),

      //add tag
      addTag: builder.mutation<TagMarketing, NewTagMarketing>({
        query: ({ label, branch_id }) => ({
          url: "admin/tags",
          method: RequestMethod.POST,
          body: { label, branch_id },
        }),
        //@ts-ignore
        invalidatesTags: (result, error, id) => [
          { type: "Tags", id },
          { type: "Tags", id: "LIST" },
        ],
      }),
      //edit tag

      updateLabel: builder.mutation({
        query: ({ id, patch }) => ({
          url: `admin/tags/${id}`,
          method: RequestMethod.PUT,
          body: patch,
        }),
        //@ts-ignore
        invalidatesTags: (result, error, id) => [
          { type: "Tags", id },
          { type: "Tags", id: "LIST" },
        ],
      }),

      deleteLabel: builder.mutation<void, number | string>({
        query: (id) => ({
          url: `labels/${id}`,
          method: RequestMethod.DELETE,
        }),
        //@ts-ignore
        invalidatesTags: (result, error, id) => [
          { type: "Tags", id },
          { type: "Tags", id: "LIST" },
        ],
      }),
    }),
  });

export const {
  useGetAllTasksQuery,
  useTasksQuery,
  useTagsQuery,
  useAddTagMutation,
  useUpdateLabelMutation,
  useDeleteLabelMutation,
  useTaskLabelsQuery,
} = taskApi;
